export default "__VITE_ASSET__DPKMfsX9__"